export default __webpack_public_path__ + "static/media/gallery_16.de26086d.jpg";